import React from 'react'
import {FormControl} from '@mui/material'
import './UploadPartExtractionForm.scss'
import {GroupOfAttributes} from '../../../../../item/model/Package'
import {DisplaySet} from '../../../../../displaySet/model/DisplaySet'
import {useGetAllDisplaySetsQuery} from '../../../../../displaySet/rtkDisplaySet'
import {Label} from '../../../../../genericComponents/typographie/Label'
import {DisplaySetsSelection} from '../../../../../displaySet/componentRelatedToDisplaySet/DisplaySetsSelection'

export const GroupOfAttributesSelection = ({
                                               onChangeDisplaySets
                                           }: {
    onChangeDisplaySets: (extractTypes: GroupOfAttributes[]) => void
}) => {
    const {data: displaySets} = useGetAllDisplaySetsQuery()

    const onSelectDisplaySet = (newDisplaySetSelected: DisplaySet[]) => {
        onChangeDisplaySets([...newDisplaySetSelected])
    }

    return (
        <FormControl className="form-select" required>
            <Label id="itemlist-label" className="itemlist-label" required={true}>
                Select Display Sets to be Extracted
            </Label>
            {displaySets && (
                <DisplaySetsSelection headerLabel="Display Sets" displaySets={displaySets}
                                      onChange={onSelectDisplaySet}/>
            )}
        </FormControl>
    )
}